import React from 'react'
import PropTypes from 'prop-types'
import { CallToAction, Paragraph } from '@scentregroup/ui'
import classnames from 'classnames'
import ExternalLink from '../external-link'
import { callToActionType } from '../../types'
import style from './index.module.scss'

const CallToActionSection = ({
  isMainCallToAction,
  callsToAction,
  title,
  listOfCategories,
}) => {
  const validCallsToAction = callsToAction.filter(cta =>
    listOfCategories.includes(cta.category)
  )

  if (!validCallsToAction || validCallsToAction.length === 0) {
    return null
  }

  return (
    <div className={classnames(style.storeFeaturesDivider, style.ctaWrapper)}>
      {title && <Paragraph className={style.ctaTitle}>{title}</Paragraph>}
      {validCallsToAction.map(cta => (
        <CallToAction
          fullWidth
          inverted={!isMainCallToAction}
          inferior={!isMainCallToAction}
          element={ExternalLink}
          className={style.cta}
          key={cta.address}
          url={cta.address}
        >
          {cta.category}
        </CallToAction>
      ))}
    </div>
  )
}

CallToActionSection.propTypes = {
  isMainCallToAction: PropTypes.bool,
  callsToAction: callToActionType,
  title: PropTypes.string,
  listOfCategories: PropTypes.array,
}

export default CallToActionSection
